// @flow
import React from "react";
import { COMMANDS } from "../../../mod-command/constants";
import { sendCommand } from "../../../mod-command/slice";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../../../notifications";
import AbstractMuteEveryoneDialog from "../AbstractMuteEveryoneDialog";
import Dialog from "../../../base/ui/components/web/Dialog";
import { translate } from "../../../base/i18n/functions";
import { connect } from "react-redux";
/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before muting all remote participants.
 *
 * @augments AbstractMuteEveryoneDialog
 */
class MuteAllDialog extends AbstractMuteEveryoneDialog {
    /**
     * Toggles advanced moderation switch.
     *
     * @returns {void}
     */
    _onToggleModeration() {
        this.setState((state) => {
            return {
                audioModerationEnabled: !state.audioModerationEnabled,
                content: this.props.t("dialog.muteEveryoneElseDialogSIP"),
            };
        });
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement(Dialog, { ok: { translationKey: 'dialog.continue' }, onSubmit: this._onSubmit, title: this.props.title },
            React.createElement("div", { className: "mute-dialog" }, this.state.content)));
    }
    _onSubmit() {
        const { dispatch, exclude } = this.props;
        //TODO: off tat ca micro phong hop
        dispatch(sendCommand(COMMANDS.MIC_SIP.COMMAND, COMMANDS.MIC_SIP.OFF));
        // if (this.state.audioModerationEnabled) {
        //     dispatch(requestEnableAudioModeration());
        // } else if (this.state.audioModerationEnabled !== undefined) {
        //     dispatch(requestDisableAudioModeration());
        // }
        dispatch(showNotification({
            titleKey: 'notify.mutedAllSIP'
        }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        return true;
    }
}
function mapStateToProps(state, ownProps) {
    const { t } = ownProps;
    const { password } = state["features/base/conference"];
    return {
        password: password,
        title: t("dialog.muteEveryoneElseTitle", { who: t("dialog.SIP") }),
        content: t("dialog.muteEveryoneElseDialogSIP"),
    };
}
export default translate(connect(mapStateToProps)(MuteAllDialog));
